import React, { Component } from 'react';

class SignInAuto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: 'paulo@beango.io',
      password: 'testing123'
    };

    //this.handleChange = this.handleChange.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.auth.signIn({
      username: this.state.email,
      password: this.state.password//,
      //validationData: []
    })
      .then(authUser => {
        console.log(authUser);
        this.props.handleSignIn();
        //console.log(authUser.user.email);
        //this.setState({
          //email: '',
          //password: ''
        //});
      })
      .catch(error => {
        console.log(error);
        alert(error.message || JSON.stringify(error));
        if (error.code === "UserNotConfirmedException") {
          this.props.history.push('/emailconfirm/' + this.state.email);
        }
  });
}

  render() {

    return (
      <div>
        <h3>{this.props.name}</h3>
        <h3>Logging in for:</h3>
        <h3>{this.state.email}</h3>

      </div>

    );
  }
}

export default SignInAuto;



// WEBPACK FOOTER //
// ./src/components/SignInAuto.js